import { TimetableReports } from '../../../components/EvaluateTimetable/TimetableReports';

export const EvaluateOther = () => {
  return <TimetableReports topic='other' />;
};
